<h5 mat-dialog-title>Change Status &mdash; {{ reportName }}</h5>

<mat-dialog-content>
    <mat-form-field appearance="outline" class="full-width">
        <mat-label>Status</mat-label>
        <mat-select [(ngModel)]="selectedStatusId">
            <mat-option *ngFor="let option of reportStatuses" [value]="option.id">
                {{ option.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions>
    <button class="mat-raised-button" appPreventDoubleClick (throttledClick)="close()">Cancel</button>

    <button mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="save()" [disabled]="!selectedStatusId">
        Save
    </button>
</mat-dialog-actions>
